// Affiche la date locale dans un format HTML date (YYYY-MM-DD)
export const formatDateOnly = (utcDateString) => {
  if (!utcDateString) return '';
  const d = new Date(utcDateString);
  if (isNaN(d.getTime())) return '';
  return d.toISOString().split('T')[0];
};

// Affiche l’heure locale dans un format HTML time (HH:mm)
export const formatTimeOnly = (utcDateString) => {
  if (!utcDateString) return '';
  const d = new Date(utcDateString);
  if (isNaN(d.getTime())) return '';
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

// Construit une date UTC ISO à partir d’une date locale + heure locale
export const toUTCISOString = (localDateString, localTimeString) => {
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(localDateString) ||
    !/^\d{2}:\d{2}$/.test(localTimeString)
  ) {
    return null; // ne fait rien si la saisie est incomplète
  }

  const [year, month, day] = localDateString.split('-');
  const [hours, minutes] = localTimeString.split(':');

  const localDate = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes)
  );

  if (isNaN(localDate.getTime())) {
    return null; // empêche toISOString de planter
  }

  return localDate.toISOString();
};

export const getTodayDate = () => {
  const now = new Date();
  return now.toISOString().split('T')[0];
};
